import ListagemSimulacoes from "./Listagem";

export default function ListarSimulacoes() {
  return (
    //Add provider se necessário para algum modal específico da funcionalidade
        <ListagemSimulacoes />
  )
}